import { render, staticRenderFns } from "./submitWelfare.vue?vue&type=template&id=c58f38bc&scoped=true&"
import script from "./submitWelfare.vue?vue&type=script&lang=js&"
export * from "./submitWelfare.vue?vue&type=script&lang=js&"
import style0 from "./submitWelfare.vue?vue&type=style&index=0&id=c58f38bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58f38bc",
  null
  
)

export default component.exports